/* __next_internal_client_entry_do_not_use__ Providers auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// This must be first, because it sets up the global lookup.
// eslint-disable-next-line import/no-unassigned-import
import "./initialization/clientComponentSSR";
import { NextRouterContextProvider } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { ZustandLocationProvider } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { AddedToBagContextStoreProvider } from "@faire/retailer-visitor-shared/components/Notifications/AddedToBag/AddedToBagStore";
import { RetailerRoutingContextProvider } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { getSettingsValues } from "@faire/retailer-visitor-shared/serialized-data/getSettingsValues";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SettingsContextProvider } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { HCaptchaStoreProvider } from "@faire/retailer-visitor-shared/stores/domain/HCaptchaStore";
import { FreeShippingContextStoreProvider } from "@faire/retailer-visitor-shared/stores/ui/FreeShippingContextStore";
import { PromoModalContextStoreProvider } from "@faire/retailer-visitor-shared/stores/ui/PromoModalContextStore";
import { TopOfPageContextStoreProvider } from "@faire/retailer-visitor-shared/stores/ui/TopOfPageContextStore";
import { IntlProvider } from "@faire/web--source/common/localization/IntlProvider";
import { LocalizationProvider } from "@faire/web--source/common/localization/useLocalization";
import { NoSSR } from "@faire/web--source/common/NoSSR";
import { QueryClientProvider } from "@faire/web--source/common/reactQuery";
import { DefaultTheme } from "@faire/web--source/slate/Theme";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { ObservableWindowStoreProvider } from "@faire/web--source/ui/hooks/useObservableWindow";
import React, { useMemo } from "react";
import { useMemoryHistory } from "@faire/retailer/app/_lib/routing/useMemoryHistory";
import { AppEffects } from "@faire/retailer/components/App/AppEffects";
import { DevTools } from "@faire/retailer/components/App/DevTools";
import { HCaptcha } from "@faire/retailer/components/AppSignIn/HCaptcha";
import { FirstOrderIncentiveFabWrapper } from "@faire/retailer/components/FirstOrderIncentiveFab/FirstOrderIncentiveFabWrapper";
import { ReactQueryClientStoreProvider } from "@faire/retailer/services/ReactQueryClient";
import { OpeningOrderIncentivesProvider } from "@faire/retailer/stores/domain/OpeningOrderIncentivesProvider";
import { SSOContextStoreProvider } from "@faire/retailer/stores/domain/SSO/SSOContextStore";
import { AppSnackbarProvider } from "@faire/retailer/stores/ui/AppSnackbarStore";
import { Globals } from "./Globals";
import { AppInitializer } from "./initialization/AppInitializer";
import { ReactQueryDevtools } from "./ReactQueryDevtools";
import { ReactScanMonitoring } from "./ReactScanMonitoring";
import { ReactRouterCompat } from "./routing/ReactRouterCompat";
import { AppDownloadWrapper } from "./wrappers/AppDownloadWrapper";
var BaseProviders = function(param) {
    var children = param.children, memoryHistory = param.memoryHistory, publicApiKeys = param.publicApiKeys;
    var settings = useMemo(function() {
        return getSettingsValues();
    }, []);
    return /*#__PURE__*/ _jsx(SettingsContextProvider, {
        settings: settings,
        children: /*#__PURE__*/ _jsx(NextRouterContextProvider, {
            children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                children: /*#__PURE__*/ _jsx(RetailerRoutingContextProvider, {
                    children: /*#__PURE__*/ _jsxs(ReactRouterCompat, {
                        memoryHistory: memoryHistory,
                        children: [
                            /*#__PURE__*/ _jsx(ReactScanMonitoring, {
                                apiKey: publicApiKeys.REACT_SCAN_MONITORING_API_KEY
                            }),
                            /*#__PURE__*/ _jsx(ZustandLocationProvider, {}),
                            /*#__PURE__*/ _jsx(ObservableWindowStoreProvider, {
                                children: /*#__PURE__*/ _jsx(ThemeProvider, {
                                    theme: DefaultTheme,
                                    children: /*#__PURE__*/ _jsxs(QueryClientProvider, {
                                        children: [
                                            /*#__PURE__*/ _jsx(ReactQueryClientStoreProvider, {
                                                children: /*#__PURE__*/ _jsx(FreeShippingContextStoreProvider, {
                                                    children: /*#__PURE__*/ _jsx(TopOfPageContextStoreProvider, {
                                                        children: /*#__PURE__*/ _jsx(HCaptchaStoreProvider, {
                                                            children: /*#__PURE__*/ _jsx(AddedToBagContextStoreProvider, {
                                                                children: /*#__PURE__*/ _jsx(AppSnackbarProvider, {
                                                                    children: /*#__PURE__*/ _jsx(IntlProvider, {
                                                                        children: /*#__PURE__*/ _jsx(SSOContextStoreProvider, {
                                                                            children: /*#__PURE__*/ _jsx(PromoModalContextStoreProvider, {
                                                                                children: /*#__PURE__*/ _jsxs(OpeningOrderIncentivesProvider, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(AppEffects, {}),
                                                                                        children,
                                                                                        /*#__PURE__*/ _jsx(NoSSR, {
                                                                                            children: /*#__PURE__*/ _jsx(HCaptcha, {})
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(AppDownloadWrapper, {}),
                                                                                        /*#__PURE__*/ _jsx(FirstOrderIncentiveFabWrapper, {}),
                                                                                        /*#__PURE__*/ _jsx(DevTools, {})
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ReactQueryDevtools, {
                                                initialIsOpen: false
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
export var Providers = function(param) {
    var children = param.children, userAgent = param.userAgent, referer = param.referer, globals = param.globals, originalUrl = param.originalUrl, publicApiKeys = param.publicApiKeys;
    var memoryHistory = useMemoryHistory();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AppInitializer, {
                history: memoryHistory
            }),
            /*#__PURE__*/ _jsx(Globals, {
                globals: globals,
                userAgent: userAgent,
                referer: referer,
                memoryHistory: memoryHistory,
                originalUrl: originalUrl,
                children: /*#__PURE__*/ _jsx(BaseProviders, {
                    memoryHistory: memoryHistory,
                    publicApiKeys: publicApiKeys,
                    children: children
                })
            })
        ]
    });
};
